module.exports = __webpack_public_path__ + "static/media/SDFSA_2-384w.bdd8cef7.webp";